const extractTenantSlug = (cognitoDomain) => {
  if (!cognitoDomain || typeof cognitoDomain !== 'string') return '';
  const [first] = cognitoDomain.split('.');
  return first || '';
};

export default {
  auth0Enabled: (...args) => args[3]['auth0/enabled'],
  hubEnabled: (...args) => args[3]['hub/isEnabled'],
  hubUserManagementUrl: (state, getters, rootState, rootGetters) => {
    if (!rootGetters['hub/isEnabled']) return '';
    const hubConfig = rootGetters['hub/hubConfig'];
    const tenantSlug = extractTenantSlug(hubConfig?.cognitoDomain);
    if (!tenantSlug) return '';
    const suffix = process.env.HUB_ADMIN_DOMAIN;
    if (!suffix) return '';
    return `https://${tenantSlug}.${suffix}/admin-console/user-management`;
  },
  isLoggedIn: (state, getters, rootState, rootGetters) => {
    const hubEnabled = rootGetters['hub/isEnabled'];
    const auth0Enabled = rootGetters['auth0/enabled'];
    const isCrossTenantSession = rootGetters['cross-tenant/isCrossTenantSession'];
    const isRootClient = rootGetters['session/isRootClient'];
    if (isCrossTenantSession === true && !isRootClient) {
      return true;
    }
    if (hubEnabled) {
      return rootGetters['hub-session/isLoggedIn'];
    } else if (auth0Enabled) {
      return rootGetters['cs-session/isLoggedIn'];
    }
    return rootGetters['session/isTokenNotExpired']();
  },
  crossTenantSessionEnabled: (state, getters, rootState, rootGetters) => {
    const isCrossTenantSession = rootGetters['cross-tenant/isCrossTenantSession'];
    const isRootClient = rootGetters['session/isRootClient'];
    return isCrossTenantSession === true && !isRootClient;
  },
  getToken: (state, getters, rootState, rootGetters) => {
    const hubEnabled = rootGetters['hub/isEnabled'];
    const auth0Enabled = rootGetters['auth0/enabled'];

    let token;
    if (hubEnabled) {
      token = rootGetters['hub-session/token'];
    } else if (auth0Enabled) {
      token = rootGetters['cs-session/token'];
    } else {
      token = rootGetters['session/getToken'];
    }
    return token;
  }
};
